import { api_getOrder, api_getOrderActivity } from '../../utils/Orders/Orders'
import {
  ORDER_SET_DATA,
  ORDER_TOGGLE_LOADING,
  ORDER_RESET_DATA,
  ORDER_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  ORDER_TOGGLE_ACTIVITY_IS_OPEN,
  ORDER_SET_ACTIVITY,
  ORDER_TOGGLE_ACTIVITY_CONTENT_LOADING,
  ORDER_SET_ACTIVITY_ERROR,
  IAssignActivityIsOpenFields,
  IToggleActivity,
  IToggleOrderActivityContentLoading,
  IAddOrderActivityError,
} from './types'
import { setSystemError } from '../system/actions'
import { defaultErrorFeedback } from '../../actions/feedback'

const setOrderData = (data) => ({
  type: ORDER_SET_DATA,
  data,
})

export function toggleOrderLoading() {
  return { type: ORDER_TOGGLE_LOADING }
}

export const resetOrderState = () => ({ type: ORDER_RESET_DATA })

export const getOrderData = (orderNumberOrId, query: { include: string }) => (dispatch) =>
  api_getOrder(orderNumberOrId, query).then((result) => {
    if (result.status === 200) {
      dispatch(setOrderData(result.data))
    } else if (result.data.error && result.data.error.id) {
      dispatch(setSystemError(result.data.error.id))
    } else {
      dispatch(defaultErrorFeedback())
    }
  });

export function assignActivityIsOpenFields(): IAssignActivityIsOpenFields {
  return {
    type: ORDER_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  };
}
export function toggleActivity(id): IToggleActivity {
  return {
    type: ORDER_TOGGLE_ACTIVITY_IS_OPEN,
    id,
  };
}
export function toggleActivityContentLoading(id): IToggleOrderActivityContentLoading {
  return {
    type: ORDER_TOGGLE_ACTIVITY_CONTENT_LOADING,
    id,
  };
}
const setOrderActivity = (data) => ({
  type: ORDER_SET_ACTIVITY,
  data,
});
export const getOrderActivity = (orderId, activityId) => (dispatch) => api_getOrderActivity(orderId, activityId).then((result) => {
  if (result.status === 200) {
    dispatch(setOrderActivity(result.data));
    return true;
  }
  return false;
});

export function setActivityError(id, error): IAddOrderActivityError {
  return {
    type: ORDER_SET_ACTIVITY_ERROR,
    id,
    error
  };
}

